<template>
  <div class="d-flex flex-column align-items-center p-5" :style="{ height: height }">
    <img src="@images/ue-components/cowboy.png" alt="Cowboy" />
    <slot name="callToAction"></slot>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UeEmptyState',
  props: {
    height: {
      type: String,
      default: '100%',
    },
  },
})
</script>
<style lang="sass" scoped>
img
  max-width: 400px
</style>
